import { Link } from "react-router-dom";
import ballerzLogo from "../../Assets/Images/ballerz-logo-white.png";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { BallerzUsers } from "../../Client/Ballerz";
import { useUsername } from "../../Pages/UsernameContext";

function SideBar(props) {
  const location = useLocation();

  const navigate = useNavigate();

  const ballerzUsers = BallerzUsers();

  const usernames = Array.isArray(props.usernames)
    ? props.usernames
    : props.usernames
    ? [props.usernames]
    : [];

  const handleLogout = () => {
    localStorage.setItem("ballerz-user", "");
    navigate("/login");
  };

  return (
    <aside className="w-[25%] bg-[#070d27] text-white px-4 py-6 flex flex-col justify-between items-center h-full hidden sm:block">
      <div className="space-y-4 w-full flex flex-col items-start">
        {usernames && usernames?.length > 1 ? (
          usernames?.map((username, index) => (
            <div
              key={index}
              className="flex flex-row items-start text-lg font-semibold Kallisto_Bold ml-16"
            >
              <img
                className="w-[80%] h-[80%] object-contain mr-2"
                src={require(`./assets/avatar.png`)}
                alt="avatar"
              />
              {username}
            </div>
          ))
        ) : (
          <div className="flex flex-row items-start text-lg font-semibold Kallisto_Bold ml-16">
            <img
              className="w-[80%] h-[80%] object-contain mr-2"
              src={require(`./assets/avatar.png`)}
              alt="avatar"
            />
            {localStorage.getItem("ballerz-display-user")}
          </div>
        )}

        <hr className="w-[80%] border-t-2 border-[#4F55F6]" />

        <nav className="space-y-4 mt-6 flex flex-col items-center w-full">
          <div
            className={`w-[220px] pl-4 text-start text-[#3a45c8] text-lg font-semibold py-0 tracking-wide Kallisto_Bold`}
          >
            SKILLZONE
          </div>

          <Link to="/" className="w-full flex justify-center cursor-pointer">
            <button
              className={`w-[220px] pl-4 text-start text-white text-lg font-semibold py-3 tracking-wide Kallisto_Bold hover:bg-[#3a45c8] ${
                location.pathname === "/" ||
                location.pathname === "/skillzone-group"
                  ? "bg-[#4F55F6]"
                  : ""
              }`}
            >
              Latest Session
            </button>
          </Link>

          <Link
            to="/skillzone-all-time"
            className="w-full flex justify-center cursor-pointer"
          >
            <button
              className={`w-[220px] pl-4 text-start text-white text-lg font-semibold py-3 tracking-wide Kallisto_Bold hover:bg-[#3a45c8] ${
                location.pathname === "/skillzone-all-time"
                  ? "bg-[#4F55F6]"
                  : ""
              }`}
            >
              All Sessions
            </button>
          </Link>

          <Link
            to="/leaderboard"
            // state={{ username: mainUser }}
            className="w-full flex justify-center cursor-pointer"
          >
            <button
              className={`w-[220px] pl-4 text-start text-white text-lg font-semibold py-3 tracking-wide Kallisto_Bold hover:bg-[#3a45c8] ${
                location.pathname === "/leaderboard" ? "bg-[#4F55F6]" : ""
              }`}
            >
              Leaderboard
            </button>
          </Link>

          <Link
            to="/friends"
            // state={{ username: mainUser }}
            className="w-full flex justify-center cursor-pointer"
          >
            <button
              className={`w-[220px] pl-4 text-start text-white text-lg font-semibold py-3 tracking-wide Kallisto_Bold hover:bg-[#3a45c8] ${
                location.pathname === "/friends" ||
                location.pathname === "/friends/manage"
                  ? "bg-[#4F55F6]"
                  : ""
              }`}
            >
              Friends
            </button>
          </Link>

          <hr className="w-[80%] border-t-2 border-[#4F55F6]" />

          <div
            className={`w-[220px] pl-4 text-start text-red-500 text-lg font-semibold py-1 tracking-wide Kallisto_Bold`}
          >
            FIXTURES
          </div>

          <Link
            to="/fixtures"
            // state={{ username: mainUser }}
            className="w-full flex justify-center cursor-pointer"
          >
            <button
              className={`w-[220px] pl-4 text-start text-white text-lg font-semibold py-3 tracking-wide Kallisto_Bold hover:bg-red-600 ${
                location.pathname === "/fixtures" ? "bg-red-500" : ""
              }`}
            >
              Goal Highlights
            </button>
          </Link>
        </nav>
      </div>

      {/* Bottom section */}
      <div className="space-y-4 flex flex-col items-center w-full mb-20 mt-20 cursor-pointer">
        {ballerzUsers.length > 1 && (
          <Link
            to="/select-user"
            // state={{ username: mainUser }}
            className="w-full flex justify-center cursor-pointer"
          >
            <button
              className={`w-[220px] pl-4 text-start text-white border border-[#4F55F6] text-lg font-semibold py-3 tracking-wide Kallisto_Bold hover:bg-[#90DEB6] hover:text-white ${
                location.pathname === "/select-user" ? "bg-[#90DEB6]" : ""
              }`}
            >
              Switch Player
            </button>
          </Link>
        )}

        <a
          href="https://ballerz.co.uk/book-now/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <button className="w-[220px] pl-4 text-start text-white text-lg font-semibold bg-red-600 py-3 hover:bg-red-700 Kallisto_Bold mb-2">
            Re-book
          </button>
        </a>

        <button
          onClick={handleLogout}
          className="w-[220px] pl-4 text-start text-white text-lg font-semibold bg-gray-600 py-3 hover:bg-gray-700 Kallisto_Bold mb-10 cursor-pointer"
        >
          Logout
        </button>

        <div className="flex justify-center">
          <img
            src={ballerzLogo}
            alt="Ballerz Logo"
            className="h-14 object-contain"
          />
        </div>
      </div>
    </aside>
  );
}

export default SideBar;
